/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateMaintenanceRequestsRequest { 
    equipmentId?: string | null;
    facilityId?: string | null;
    facilityNameSnapshot?: string | null;
    containerNumberSnapshot?: number | null;
    rackNumberSnapshot?: number | null;
    placeNumberSnapshot?: number | null;
    equipmentModelId?: string | null;
    equipmentModelNameSnapshot?: string | null;
    serialNumber?: string | null;
    clientId?: string | null;
    clientNameSnapshot?: string | null;
    workerId?: string | null;
    workerNameSnapshot?: string | null;
    maintenanceTypeId: number;
    serviceCenterId: string;
    warrantyTypeId: number;
    errorId: number;
    comment?: string | null;
}

